<template>
    <b-modal size="xl" centered  scrollable id="modal-sous-categorie" ref="modal-sous-categorie" :title="modalTitle" @hidden="resetForm">
      <b-form>
        <b-form-group label="Catégorie" label-for="sousCategorieSelect">
          <b-form-select
            id="categorieSelect"
            :plain="true"
            :options="categoryOptions"
            v-model="selectedCategory"
            :class="{hasError: errors.categorie_id !== ''}">
            <template #first>
              <b-form-select-option :value="null">Sélectionnez une catégorie</b-form-select-option>
            </template>
          </b-form-select>
          <span class="field-error">{{ errors.categorie_id }}</span>
        </b-form-group>
        <b-form-group
            label='Libellé'
            label-for='libelle'
          >
          <b-form-input id='libelle' type='text' v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
          <span class="field-error">{{ errors.libelle }}</span>
        </b-form-group>
        <b-form-group
            description='En minuscule sans accent ni espace (mettre un _ à la place)'
            label='Libellé technique'
            label-for='libelle_technique'
          >
          <b-form-input id='libelle_technique' type='text' v-model="libelle_technique" :disabled="!isEmpty(selectedSousCategory)" :class="{hasError: errors.libelle_technique !== ''}"></b-form-input>
          <span class="field-error">{{ errors.libelle_technique }}</span>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="md"
            class="float-left"
            @click="resetForm()"
          >
            Fermer
          </b-button>
          <b-button type="button" @click="submitForm" size="md" variant="primary" class="float-right">
            <i class="fa fa-save"></i> Enregistrer
          </b-button>
        </div>
      </template>
    </b-modal>
  </template>

  <script>
    import {isEmpty} from "@/utils/fileHelper";

  export default {
    props: {
      selectedSousCategory: {
        type: Object
      },
      categoryOptions: {
        type: Array
      }
    },
    data() {
      return {
        isEmpty,
        libelle: '',
        libelle_technique: '',
        categorie_id: '',
        modalTitle: 'Création d\'une sous-catégorie de document',
        selectedCategory: null,
        errors: {
          libelle: '',
          libelle_technique: '',
          categorie_id: '',
        }
      }
    },
    watch: {
      selectedSousCategory(sousCategorie) {
        if (!isEmpty(sousCategorie)) {
          this.modalTitle = 'Modification de sous-catégorie de document';
          this.libelle = this.selectedSousCategory.libelle;
          this.libelle_technique = this.selectedSousCategory.libelle_technique;
          this.selectedCategory = this.selectedSousCategory.categorie_id;
        }
      },
    },
    methods: {
      submitForm() {
        if (this.validateData()) {
          let self = this;
          let dataPost = {};

          dataPost.libelle = this.libelle;
          dataPost.libelle_technique = this.libelle_technique;
          dataPost.categorie_id = this.selectedCategory;
          dataPost.sousCategorieId = !isEmpty(this.selectedSousCategory) ? this.selectedSousCategory.id : '';

          this.$store.commit("IS_LOADING", true);
          this.$axios
            .post("/espaceBibliotheque/sous-categorie", dataPost)
            .then(response => {
              this.$store.commit("IS_LOADING", false);
              this.$refs['modal-sous-categorie'].hide();
              this.resetForm();
              this.$event.emit('refresh-sous-categorie-document');
              this.$event.emit('refresh-after-new-sous-categorie', response.data.sousCategorie);
              let title = !isEmpty(this.selectedSousCategory) ? 'Modification avec succès' : 'Création avec succès';
              let texte = !isEmpty(this.selectedSousCategory) ? 'La sous-catégorie de document a bien été modifiée' : 'La sous-catégorie de document a bien été créée';
              this.$swal({
                position: "top",
                type: "success",
                title: title,
                text: texte,
                showConfirmButton: false,
                timer: 5000
              });
            })
            .catch(function(error) {
              self.$store.commit("IS_LOADING", false);
              let text = 'Une erreur est survenue pendant la création de la sous-catégorie, si le problème persiste merci de contacter le support DOSI';
              if (!isEmpty(error) && error.response && error.response.status === 403) {
                text = error.response.data.message;
                self.errors.libelle_technique = 'Libellé technique déjà utilisé';
              }
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text: text,showConfirmButton: false, timer: 10000})
            });
        }
      },
      resetForm() {
        this.libelle = '';
        this.libelle_technique = '';
        this.selectedCategory = '';
        this.$bvModal.hide('modal-sous-categorie')
      },
      clearErrors() {
        this.errors.libelle = '';
        this.errors.libelle_technique = '';
        this.errors.categorie_id = '';
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (isEmpty(this.libelle)) {
          this.errors.libelle = 'Le libellé est obligatoire';
          valid = false;
        }
        if (isEmpty(this.libelle_technique)) {
          this.errors.libelle_technique = "Le libellé technique est obligatoire";
          valid = false;
        }
        if (isEmpty(this.selectedCategory)) {
          this.errors.categorie_id = "La catégorie est obligatoire";
          valid = false;
        }
        return valid;
      },
    }
  }
  </script>
  <style scoped>
  </style>
